import workflow from './workflow';
import workflowStage from './workflow-stage';

export default {
  workflow,
  'workflow-stage': workflowStage,
};
